import React from 'react';

function PrivacyPolicy({ policyText, title, isVisible }) {
  return (
    <div className={`policy-section ${isVisible ? '' : 'fade-out'}`}>
      <h2>{title}</h2>
      <div className={`policy-content ${isVisible ? 'fade-in' : 'fade-out'}`}>
        {policyText}
      </div>
    </div>
  );
}

export default PrivacyPolicy; 